const resetPassword: { [key: string]: any } = {
    "Auth.form.error.code.provide": "Código inválido",
    "Auth.form.error.password.matching": "Confirmação de senha incorreta",
};

export default resetPassword;
